import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './core/services/auth-guard.service';
import { FaqMainComponent } from './modules/faq/faq-main/faq-main.component';
import { CopRedirectComponent } from './modules/redirects/cop-redirect/cop-redirect.component';

const routes: Routes = [
    {
        path: '',
        component: FaqMainComponent,
        children: [
            {
                path: 'auth',
                loadChildren: () => import('src/app/modules/faq/faq-authentication/faq-authentication.module')
                    .then(x => x.FaqAuthenticationModule)
            },
            {
                path: '',
                canActivate: [AuthGuardService],
                data: {
                    canActivateReturnUrl: 'auth',
                    permissions: [
                        'faq-user'
                    ]
                },
                loadChildren: () => import ('src/app/modules/faq/faq-home-simple/faq-home-simple.module')
                    .then(x => x.FaqHomeSimpleModule)
            }
        ]
    },
    {
        path: 'faqbereichag',
        component: FaqMainComponent,
        children: [
            {
                path: '',
                loadChildren: () => import ('src/app/modules/faq/faq-home-simple/faq-home-simple.module')
                    .then(x => x.FaqHomeSimpleModule)
            },
        ]
    },
    {
        path: 'steuerfinanziert-mehr-netto',
        component: FaqMainComponent,
        children: [
            {
                path: '',
                loadChildren: () => import ('src/app/modules/faq/faq-home-tax-financed/faq-home-tax-financed.module')
                    .then(x => x.FaqHomeTaxFinancedModule)
            },
        ]
    },
    {
        path: 'consultancy-process',
        component: CopRedirectComponent,
        children: [
            {
                path: 'authentication',
                component: CopRedirectComponent
            }
        ]
    },
    {path: '**', redirectTo: '/auth', pathMatch: 'full'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
